// @flow

import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import i18n from "i18next";
import k from "src/i18n/keys";

import {
  getChecklistFieldDetails,
  getRoomFieldValueStatus,
  getIsFieldLocked,
  getLockedStatus,
} from "src/reducers";
import { dataStages } from "src/constants";
import { aiErrors } from "src/constants/errorMessages";
import { setChecklistValue } from "src/actions/checklist";
import ButtonLoader from "src/components/Dock/Checklist/Conversation/Loader";
import { AddButton as AiButton } from "./styles";

import type { FieldId, RoomId } from "src/types";

type Props = {
  formId?: ?number,
  roomId: RoomId,
  fieldId: FieldId,
  roomFieldFormId?: ?string,
};

const Ai = ({ formId, roomId, fieldId, roomFieldFormId }: Props) => {
  const dispatch = useDispatch();

  const fieldDetails = useSelector(({ app }) =>
    getChecklistFieldDetails(app, `${fieldId}`),
  );

  const fieldValueStatus = useSelector(({ app }) =>
    getRoomFieldValueStatus(app, fieldId, roomId),
  );

  const isChecklistFieldLocked = useSelector(({ app }) =>
    getLockedStatus(app, roomId, fieldId),
  );
  const isFormFieldLocked = useSelector(({ app }) =>
    getIsFieldLocked(app, roomFieldFormId, fieldId, roomId),
  );
  const locked = formId ? isFormFieldLocked : isChecklistFieldLocked;

  // $FlowFixMe - !optional chaining
  const fieldSettings = JSON.parse(fieldDetails?.get("settings"));

  const isUpdating = fieldValueStatus === dataStages.updating;

  const setFieldValue = useCallback(() => {
    if (
      fieldSettings?.inputFields?.length === 0 ||
      fieldSettings?.ouputFields?.length === 0
    ) {
      toast.error(aiErrors.UNABLE_TO_GENERATE_AI_SUGGESTION);
      return;
    }

    dispatch(
      setChecklistValue({
        roomId,
        id: fieldId,
        value: {
          value: null,
          type: "ai",
          checked: true,
        },
        progress: true,
        formId,
      }),
    );
  }, [roomId, fieldId]);

  const placeholder = fieldSettings.placeholder || i18n.t(k.BUILD_WITH_AI);

  return isUpdating ? (
    <ButtonLoader />
  ) : (
    <AiButton onClick={setFieldValue} disabled={locked}>
      <span>🪄 {placeholder} (Beta) </span>
    </AiButton>
  );
};

export default Ai;
